import React from "react";
import { Check, X } from "lucide-react";
import useReveal from "../../hooks/useReveal";

const steps = [
  {
    t: "Confirmamos y arrancamos",
    d: "Con tu aprobación, damos inicio al desarrollo de tu página.",
  },
  {
    t: "Diseñamos y desarrollamos",
    d: "Construimos tu página con la información que nos compartiste.",
  },
  {
    t: "Ajustamos contigo",
    d: "Aplicamos la ronda de ajustes incluida antes de publicar.",
  },
  {
    t: "Publicamos",
    d: "Tu página queda en línea y lista para recibir visitas.",
  },
];

const includes = [
  "Diseño adaptado a tu identidad",
  "Presentación principal",
  "Servicios",
  "WhatsApp directo",
  "Formulario de contacto",
  "Información de contacto",
  "SEO técnico básico",
  "FAQ",
  "Optimización móvil, tablet y escritorio",
  "Ronda de ajustes inicial",
  "Opciones administrables según el proyecto",
  "Capacitación cuando corresponda",
];

const notIncludes = [
  "Base de datos",
  "Login de usuarios",
  "Panel administrativo",
  "Carrito de compras",
  "Pagos en línea",
  "Reservaciones automáticas",
  "Integraciones avanzadas",
  "Desarrollo a la medida",
];

const Process = () => {
  useReveal();
  return (
    <>
      <section
        id="proceso"
        data-testid="section-proceso"
        className="bdk-section"
      >
        <div className="container-bdk">
          <div className="max-w-[760px] mx-auto text-center mb-14 bdk-reveal bdk-reveal--up">
            <p className="kicker">Cómo trabajamos</p>
            <h2 className="font-display text-[38px] sm:text-[48px] md:text-[56px] lg:text-[64px]">
              Así convertimos tu idea
              <br />
              en una página profesional.
            </h2>
            <p className="mt-5 text-[#666873] text-[13px] md:text-[14px]">
              Los tiempos dependen del tipo de proyecto y comienzan a contar
              cuando nos entregas la información requerida. Una landing page
              sencilla se entrega en aproximadamente 7 días hábiles.
            </p>
          </div>

          <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
            {steps.map((s, i) => (
              <article
                key={s.t}
                data-testid={`process-step-${i}`}
                className="p-7 rounded-[12px] bdk-reveal bdk-reveal--up"
                style={{
                  background: "var(--paper)",
                  border: "1px solid var(--line)",
                  "--reveal-delay": `${i * 70}ms`,
                }}
              >
                <span className="font-display text-[50px] font-black text-[#d90020] leading-none block">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <h3 className="font-display text-[22px] mt-2">{s.t}</h3>
                <p className="mt-2 text-[#666873] text-[12px]">{s.d}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section
        id="incluye"
        data-testid="section-incluye"
        className="bdk-section"
        style={{ background: "var(--paper)" }}
      >
        <div className="container-bdk grid lg:grid-cols-2 gap-6">
          <div
            className="rounded-[14px] bg-white p-8 md:p-10 bdk-reveal bdk-reveal--up"
            style={{ border: "1px solid var(--line)" }}
          >
            <p className="kicker">Sí incluye</p>
            <h3 className="font-display text-[32px] md:text-[36px] leading-none">
              Qué incluye un proyecto web
            </h3>
            <p className="text-[#666873] text-[13px] mt-2">
              Tu página puede incluir todo lo necesario para presentar mejor tu
              negocio.
            </p>
            <ul className="mt-6 grid grid-cols-2 gap-2 list-none">
              {includes.map((it) => (
                <li
                  key={it}
                  className="relative pl-5 text-[13px] text-[#111218]"
                >
                  <Check
                    size={14}
                    className="absolute left-0 top-[3px]"
                    style={{ color: "var(--red)" }}
                  />
                  {it}
                </li>
              ))}
            </ul>
            <p className="mt-6 text-[11px] text-[#999aa2] leading-relaxed">
              Dominio y hosting se cotizan por separado salvo que una
              propuesta indique lo contrario. Funcionalidades adicionales
              pueden modificar la cotización. Qué tan "administrable" es tu
              página depende del producto contratado.
            </p>
          </div>
          <div
            className="rounded-[14px] p-8 md:p-10 text-white bdk-reveal bdk-reveal--up"
            style={{ background: "var(--ink)" }}
          >
            <p className="kicker" style={{ color: "#ff5f6f" }}>
              No incluye
            </p>
            <h3 className="font-display text-[32px] md:text-[36px] leading-none">
              Una landing no es un sistema web
            </h3>
            <p className="text-[#b8b9c1] text-[13px] mt-2">
              Si necesitas funcionalidades especiales, se cotiza como proyecto
              personalizado.
            </p>
            <ul className="mt-6 grid grid-cols-2 gap-2 list-none">
              {notIncludes.map((it) => (
                <li
                  key={it}
                  className="relative pl-5 text-[13px] text-white/90"
                >
                  <X
                    size={14}
                    className="absolute left-0 top-[3px]"
                    style={{ color: "var(--red)" }}
                  />
                  {it}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </>
  );
};

export default Process;
